/**
 * True when the facility type slug is RHC or FQHC (AB#10983 / AB#10969).
 * Normalizes hyphens to underscores before comparison.
 */
export function isRhcOrFqhc(slug?: string | null): boolean {
  if (!slug) return false;
  const s = slug.trim().toLowerCase().replace(/-/g, "_");
  return (
    s === "rural_health_clinic" ||
    s === "federally_qualified_health_center" ||
    s === "rhc" ||
    s === "fqhc"
  );
}
